<ng-container *ngIf=" loading$| async">
  <div class="spinner-container">
    <div class="spinner"></div>
    <ng-container *ngIf="(message$ | async ) as message">
      <div class="spinner-message">{{message}}</div>
    </ng-container>
  </div>
</ng-container>
